import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CanvasService {
  public mathLevels = [];
  private drawOnCanvas$: Subject<any> = new Subject();
  private isAbcPressed$: Subject<{
    isAbcPressed: boolean;
    callToggle?: boolean;
  }> = new Subject();
  private isAnyInputPopupOpen$: Subject<boolean> = new Subject();
  private isAnyAlterPopupOpen$: Subject<boolean> = new Subject();
  private shortCutsKey$: Subject<string> = new Subject();

  /**
   * listen to key to draw on canvas
   * @returns Subject
   */
  getMathKeysToDraw(): Observable<any> {
    return this.drawOnCanvas$.asObservable();
  }
  /**
   * update the key to draw on canvas
   */
  setMathKeysToDraw(key: string, group: any, type: any): void {
    this.drawOnCanvas$.next({ key, group, type });
  }
  /**
   * listen to Abc click update
   * @returns Subject
   */
  getIsAbcPressed() {
    return this.isAbcPressed$.asObservable();
  }
  /**
   * update the if abc key is clicked
   * @param value
   */
  setIsAbcPressed(value: { isAbcPressed: boolean; callToggle?: boolean }) {
    if (value.callToggle === undefined) {
      value.callToggle = true;
    }
    this.isAbcPressed$.next(value);
  }
  /**
   * listen to if any input is open in modal
   * @returns Subject
   */
  getIsAnyInputPopupOpen() {
    return this.isAnyInputPopupOpen$.asObservable();
  }
  /**
   * update the value of isAnyInputinPopup
   * @param value
   * @returns
   */
  setIsAnyInputPopupOpen(value: boolean) {
    return this.isAnyInputPopupOpen$.next(value);
  }
  /**
   * listen to if any Alter key is opened
   * @returns Subject
   */
  getIsAnyAlterPopupOpen() {
    return this.isAnyAlterPopupOpen$.asObservable();
  }
  /**
   * Update the vaue of if Alter key popup is open
   * @param value
   * @returns
   */
  setIsAnyAlterPopupOpen(value: boolean) {
    return this.isAnyAlterPopupOpen$.next(value);
  }
  /**
   * Listen to keyboard shortcuts
   * @returns
   */
  getShortCutsKey() {
    return this.shortCutsKey$.asObservable();
  }
  /**
   * Update the value of shotcuts keys
   * @param value
   */
  setShortCutsKey(value: string) {
    this.shortCutsKey$.next(value);
  }
}
